var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip",class:_vm.classes,style:(_vm.style)},[_vm._t("default",null,{"active":_vm.active})],2)}
var staticRenderFns = []

export { render, staticRenderFns }